module.exports = __webpack_public_path__ + "img/ipn.fbd097fc.jpeg";